﻿const submitBtnSelector = '[data-rebtn]';
const recaptchaTokenSelector = '[name*=RecaptchaToken]';

/**
 * Initialize reCAPTCHA bindings for elements matching `submitBtnSelector`.
 * @param {string} recaptchaApiKey - reCAPTCHA site key
 */
export function initRecaptchas(recaptchaApiKey) {
  const btns = document.querySelectorAll(submitBtnSelector);

  btns.forEach((btn) => {
    if (btn.dataset.recaptchaBound) return;
    btn.dataset.recaptchaBound = 'true';

    btn.addEventListener('click', async (event) => {
      event.preventDefault();

      const target = event.currentTarget;
      if (!target) return;

      const form = target.form;
      if (!form) return;

      const recaptchaInput = form.querySelector(recaptchaTokenSelector);
	  if (recaptchaInput) {
        await setRecaptchaToken(recaptchaApiKey, form, recaptchaInput, target);
      }
    });
  });
}

/**
 * Request reCAPTCHA v3 / Enterprise token and submit the form when obtained.
 * Only site-key (v3) style is supported.
 */
async function setRecaptchaToken(recaptchaApiKey, form, element, btn) {
  try {
    if ('disabled' in btn) btn.disabled = true;
  } catch (e) {
    // ignore if element doesn't support disabled
  }

  if (!window.grecaptcha) {
    console.error('reCAPTCHA not loaded (window.grecaptcha is undefined)');
    try {
      if ('disabled' in btn) btn.disabled = false;
    } catch (e) {
      // ignore
    }
    return;
  }

  // Prefer enterprise API when available, otherwise use regular grecaptcha
  const api = (window.grecaptcha.enterprise ?? window.grecaptcha);

  api.ready(() => {
    const callExecute = () => api.execute(String(recaptchaApiKey));

    Promise.resolve(callExecute())
      .then((token) => {
        if (!token) {
          throw new Error('reCAPTCHA did not return a token');
		}

        element.value = token;
        form.submit();
      })
      .catch((err) => {
        console.error(err);
        try {
          if ('disabled' in btn) btn.disabled = false;
        } catch (e) {
          // ignore
        }
      });
  });
}
